import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiPointOfSaleList = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/point-of-sale/`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiPointOfSaleDetail = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/point-of-sale/${id}`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiPointOfSaleDownload = async (format, filters) => {
  try {
    const acceptHeader =
        format === 'csv'
            ? 'text/csv'
            : 'application/vnd.ms-excel';

    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/point-of-sale/report/`, filters),
        {
          method: 'GET',
          headers: {
            ...buildHeaders(),
            Accept: acceptHeader,
          },
        }
    );

    return response.blob();
  } catch (error) {
    throw error;
  }
};

export const apiTerminalRegister = async (selectedAccountId, token) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/related/${selectedAccountId}/register-pos/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify({ token })
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiPointOfSaleUpdate = async (id, dataJSON) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/unified/accounts/sellers/${getSellerID()}/point-of-sale/${id}/`, {
      method: "PATCH",
      headers: buildHeaders(),
      body: JSON.stringify(dataJSON)
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
